import { GetterTree } from "vuex";
import { RootState } from "../types";
import { ConfigState } from "./types";
import { Societe, Profil } from "@/shared/Groupe";
import { User } from "@/shared/User";
import { Site } from "@/shared/Site";

export const getters: GetterTree<ConfigState, RootState> = {
  societes(state): Societe[] {
    if (localStorage.societes) {
      state.societes = JSON.parse(localStorage.societes);
      return state.societes;
    }
    return [];
  },
  profils(state): Profil[] {
    if (state.profils && state.profils.length > 0) {
      return state.profils;
    }
    return [];
  },
  utilisateurs(state): User[] {
    if (state.utilisateurs) {
      return state.utilisateurs;
    }
    return [];
  },
  fecRestaurantId(state): number | null {
    return state.fecRestaurantId;
  },
  societesACreer(state): Site[] {
    if (state.societesACreer) {
      return state.societesACreer;
    }
    return [];
  },
  groupes(state) {
    if (state.groupes) {
      return state.groupes;
    }
    return [];
  },
};
